var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": { minWidth: "100vw", minHeight: "100vh" },
        "no-backdrop-dismiss": "",
        "no-esc-dismiss": ""
      },
      model: {
        value: _vm.show_report,
        callback: function($$v) {
          _vm.show_report = $$v
        },
        expression: "show_report"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    _vm.show_report = false
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v(
                  "\n                " + _vm._s(_vm.title) + "\n            "
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "layout-padding" },
            [
              _c(
                "q-tabs",
                {
                  staticClass: "shadow-1",
                  attrs: { color: "secondary" },
                  model: {
                    value: _vm.tab,
                    callback: function($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                [
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "certificates",
                      icon: "fal fa-file-certificate",
                      label: _vm.$t("certificates")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "tests",
                      icon: "fal fa-users-class",
                      label: _vm.$t("tests")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "participants",
                      icon: "fal fa-users",
                      label: _vm.$t("participants")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "registrations",
                      icon: "fal fa-ballot-check",
                      label: _vm.$t("registrations")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "availables",
                      icon: "fal fa-users",
                      label: _vm.$t("availables")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "support_material",
                      icon: "fal fa-download",
                      label: _vm.$t("support_material")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "reaction_tests",
                      icon: "fal fa-clipboard-list-check",
                      label: _vm.$t("reaction_tests")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "stars",
                      icon: "fal fa-star",
                      label: _vm.$t("comments")
                    },
                    slot: "title"
                  }),
                  _c(
                    "q-tab-pane",
                    {
                      staticClass: "q-px-lg q-pb-xl",
                      attrs: { name: "certificates", "keep-alive": "" }
                    },
                    [
                      _c("certificates", {
                        attrs: {
                          load:
                            _vm.tab === "certificates" &&
                            _vm.show_report_webcast
                              ? true
                              : false,
                          id: _vm.id
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    {
                      staticClass: "q-px-lg q-pb-xl",
                      attrs: { name: "tests", "keep-alive": "" }
                    },
                    [
                      _c("tests", {
                        attrs: {
                          load:
                            _vm.tab === "tests" && _vm.show_report_webcast
                              ? true
                              : false,
                          id: _vm.id,
                          permissions: _vm.permissions
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    {
                      staticClass: "q-px-lg q-pb-xl",
                      attrs: { name: "participants", "keep-alive": "" }
                    },
                    [
                      _c("participants", {
                        attrs: {
                          load:
                            _vm.tab === "participants" &&
                            _vm.show_report_webcast
                              ? true
                              : false,
                          id: _vm.id,
                          webcast_type: _vm.webcast_type
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    {
                      staticClass: "q-px-lg q-pb-xl",
                      attrs: { name: "registrations", "keep-alive": "" }
                    },
                    [
                      _c("registrations", {
                        attrs: {
                          load:
                            _vm.tab === "registrations" &&
                            _vm.show_report_webcast
                              ? true
                              : false,
                          id: _vm.id
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    {
                      staticClass: "q-px-lg q-pb-xl",
                      attrs: { name: "availables", "keep-alive": "" }
                    },
                    [
                      _c("availables", {
                        attrs: {
                          load:
                            _vm.tab === "availables" && _vm.show_report_webcast
                              ? true
                              : false,
                          id: _vm.id,
                          permissions: _vm.permissions
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    {
                      staticClass: "q-px-lg q-pb-xl",
                      attrs: { name: "support_material", "keep-alive": "" }
                    },
                    [
                      _c("support-material", {
                        attrs: {
                          load:
                            _vm.tab === "support_material" &&
                            _vm.show_report_webcast
                              ? true
                              : false,
                          id: _vm.id
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    {
                      staticClass: "q-px-lg q-pb-xl",
                      attrs: { name: "reaction_tests", "keep-alive": "" }
                    },
                    [
                      _c("reaction-test", {
                        attrs: {
                          load:
                            _vm.tab === "reaction_tests" &&
                            _vm.show_report_webcast
                              ? true
                              : false,
                          id: _vm.id
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    {
                      staticClass: "q-px-lg q-pb-xl",
                      attrs: { name: "stars", "keep-alive": "" }
                    },
                    [
                      _c("comments", {
                        attrs: {
                          load:
                            _vm.tab === "stars" && _vm.show_report_webcast
                              ? true
                              : false,
                          id: _vm.id,
                          permissions: _vm.permissions
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }